import PropTypes from 'prop-types';
import React from 'react';

import { Symbols } from '@powdr/constants';
import { getIcon, getSnowfallMeasurementUnit } from '@powdr/utils';

import {
  ForecastDesc, ForecastIcon, SnowfallValues,
  StyledDorForecastItem, TemperatureValues, Date,
  Section,
} from './styles';

export const DorForecastItem = ({
  className = '',
  temperature,
  snowfall = { min: null, max: null },
  date,
  description = null,
  icon = null,
  isFitToContent = false,
}) => {
  const measurementUnit = getSnowfallMeasurementUnit();

  return (
    <StyledDorForecastItem
      className={className}
      $isFitToContent={isFitToContent}
    >
      <Section>
        <ForecastIcon name={getIcon(icon)} height="50" width="50" />
        <TemperatureValues>
          {`${temperature.min}${Symbols.DEGREE}/${temperature.max}${Symbols.DEGREE}`}
        </TemperatureValues>
        {(Object.values(snowfall).filter((x) => x).length !== 0) && (
        <SnowfallValues>
          {`${snowfall.min}${measurementUnit} / ${snowfall.max}${measurementUnit}`}
        </SnowfallValues>
        )}
      </Section>
      <Section>
        {date && (<Date>{date}</Date>)}
        {description && (<ForecastDesc>{description}</ForecastDesc>)}
      </Section>
    </StyledDorForecastItem>
  );
};

DorForecastItem.propTypes = {
  className: PropTypes.string,
  temperature: PropTypes.shape({
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  snowfall: PropTypes.shape({
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  icon: PropTypes.string,
  isFitToContent: PropTypes.bool,
};
